export const source = {
    id: 'id',
    productId: 'product_id',
    productName: 'product_name',
    productSlug: 'product_slug',
    status: 'status',
    updatedAt: 'updated_at',
    content: 'content',
    contentTitle: 'content.title',
    contentSections: 'content.sections',
    product: 'product',
};

export const DYNAMIC_SECTION_SLUGS = [
    'guides-and-rate-bulletins',
    'training-and-job-aids',
    'related-articles',
];

export const STRUCTURED_SECTION_SLUGS = [
    'new-overview',
    'overview',
    'bundle',
    'features-and-benefits',
    'discounts',
    'end-text',
];

export const SECTION_DEFAULT_TITLES = {
    'new-overview': 'Product Highlights',
    'discounts': 'Discounts',
    'end-text': 'Disclaimers / Footer Notes',
};

export const FEATURE_ICON_CHOICES = [
    { id: 'accident.svg', name: 'accident.svg' },
    { id: 'agency-locations-icon.svg', name: 'agency-locations-icon.svg' },
    { id: 'agent-friendly.svg', name: 'agent-friendly.svg' },
    { id: 'atvs_and_boats.png', name: 'atvs_and_boats.png' },
    { id: 'auto_5/accident_forgiveness.svg', name: 'auto_5/accident_forgiveness.svg' },
    { id: 'auto_5/additional_coverages.svg', name: 'auto_5/additional_coverages.svg' },
    { id: 'auto_5/auto_extra.svg', name: 'auto_5/auto_extra.svg' },
    { id: 'auto_5/declining_deductible.svg', name: 'auto_5/declining_deductible.svg' },
    { id: 'auto_5/liability_coverage.svg', name: 'auto_5/liability_coverage.svg' },
    { id: 'auto_5/medical_expense.svg', name: 'auto_5/medical_expense.svg' },
    { id: 'auto_5/travel_package.svg', name: 'auto_5/travel_package.svg' },
    { id: 'auto_5/uninsured_motorist.svg', name: 'auto_5/uninsured_motorist.svg' },
    { id: 'auto_5/vehicle_replacement_plus.svg', name: 'auto_5/vehicle_replacement_plus.svg' },
    { id: 'bill.svg', name: 'bill.svg' },
    { id: 'blanket.svg', name: 'blanket.svg' },
    { id: 'boat.svg', name: 'boat.svg' },
    { id: 'builders-risk.svg', name: 'builders-risk.svg' },
    { id: 'business-processing.svg', name: 'business-processing.svg' },
    { id: 'care.svg', name: 'care.svg' },
    { id: 'check-field.svg', name: 'check-field.svg' },
    { id: 'comp.svg', name: 'comp.svg' },
    { id: 'cyber.svg', name: 'cyber.svg' },
    { id: 'deductible.svg', name: 'deductible.svg' },
    { id: 'endorsement.svg', name: 'endorsement.svg' },
    { id: 'farm_ranch.png', name: 'farm_ranch.png' },
    { id: 'field.svg', name: 'field.svg' },
    { id: 'gavel.svg', name: 'gavel.svg' },
    { id: 'gear.svg', name: 'gear.svg' },
    { id: 'glass.svg', name: 'glass.svg' },
    { id: 'guest.svg', name: 'guest.svg' },
    { id: 'headset.svg', name: 'headset.svg' },
    { id: 'home-protection.svg', name: 'home-protection.svg' },
    { id: 'hurricane.svg', name: 'hurricane.svg' },
    { id: 'key.svg', name: 'key.svg' },
    { id: 'legal.svg', name: 'legal.svg' },
    { id: 'management.svg', name: 'management.svg' },
    { id: 'motorcycle.svg', name: 'motorcycle.svg' },
    { id: 'multi-carrier.svg', name: 'multi-carrier.svg' },
    { id: 'niche.svg', name: 'niche.svg' },
    { id: 'non-owned.svg', name: 'non-owned.svg' },
    { id: 'parts-gear.svg', name: 'parts-gear.svg' },
    { id: 'piggy-bank.svg', name: 'piggy-bank.svg' },
    { id: 'pools_and_trampolines.png', name: 'pools_and_trampolines.png' },
    { id: 'pricing.svg', name: 'pricing.svg' },
    { id: 'protection.svg', name: 'protection.svg' },
    { id: 'referral.svg', name: 'referral.svg' },
    { id: 'replacement.svg', name: 'replacement.svg' },
    { id: 'rental_properties.png', name: 'rental_properties.png' },
    { id: 'rental_property_exposures.png', name: 'rental_property_exposures.png' },
    { id: 'sales-support.svg', name: 'sales-support.svg' },
    { id: 'save-money.svg', name: 'save-money.svg' },
    { id: 'savings.svg', name: 'savings.svg' },
    { id: 'scheduler.svg', name: 'scheduler.svg' },
    { id: 'search-list.svg', name: 'search-list.svg' },
    { id: 'shipped.svg', name: 'shipped.svg' },
    { id: 'sunny.svg', name: 'sunny.svg' },
    { id: 'surface.svg', name: 'surface.svg' },
    { id: 'towing.svg', name: 'towing.svg' },
    { id: 'uninsured_underinsured_motorist.png', name: 'uninsured_underinsured_motorist.png' },
    { id: 'vacant_land.png', name: 'vacant_land.png' },
    { id: 'vehicle.svg', name: 'vehicle.svg' },
    { id: 'verified.svg', name: 'verified.svg' },
    { id: 'water.svg', name: 'water.svg' },
    { id: 'wealth.svg', name: 'wealth.svg' },
    { id: 'world.svg', name: 'world.svg' },
];

export const SECTION_STATUS_CHOICES = [
    { id: 'published', name: 'Published' },
    { id: 'draft', name: 'Draft' },
];

export const PAGE_STATUS_CHOICES = [
    { id: 'published', name: 'Published' },
    { id: 'draft', name: 'Draft' },
];
